import { CustomFilter } from '@/types';

import { toCustomFilterMutationInput } from './resourceMutationPayloads';
import { createSanitizedResourceService, QueryParams } from './resources';

const base = createSanitizedResourceService<
    CustomFilter,
    ReturnType<typeof toCustomFilterMutationInput>,
    ReturnType<typeof toCustomFilterMutationInput>
>('/api/custom-filters', toCustomFilterMutationInput, toCustomFilterMutationInput);

export const customFilterService = {
    ...base,
    list: <TParams extends QueryParams = QueryParams>(params?: TParams) => base.list(params),
};
